import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/motion";
import { insights } from "@/data/insights";

export default function InsightsBand() {
  const latest = insights.slice(0, 3);
  return (
    <section className="bg-white text-ink sec" data-testid="insights-section">
      <div className="wrap">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-12">
          <Reveal>
            <h2 className="h-display font-bold text-[32px] sm:text-5xl lg:text-[56px] leading-[1.06]">
              Perspectives on ESG & sustainability.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <Link to="/insights" className="u-sweep inline-flex items-center gap-2 font-bold text-[14px] text-ink" data-testid="insights-view-all">
              View All Insights <ArrowRight size={15} />
            </Link>
          </Reveal>
        </div>
        <div className="grid md:grid-cols-3 gap-8 lg:gap-10" data-testid="insights-cards">
          {latest.map((a, i) => (
            <Reveal key={a.slug} delay={i * 0.08}>
              <Link to={`/insights/${a.slug}`} className="group flex flex-col h-full border-t-2 border-gold pt-6" data-testid={`insight-card-${a.slug}`}>
                <p className="eyebrow text-ink/45">{a.category}</p>
                <h3 className="h-display font-bold text-[19px] sm:text-xl mt-4 leading-snug group-hover:text-gold transition-colors duration-300">
                  {a.title}
                </h3>
                <p className="text-ink/60 text-[14px] mt-3 leading-relaxed line-clamp-3 flex-1">{a.excerpt}</p>
                <span className="inline-flex items-center gap-2 mt-6 font-bold text-[13px] text-ink group-hover:text-gold transition-colors">
                  Read article <ArrowRight size={14} />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
